import React, { Fragment } from 'react';

import { PageTitle } from '../../../layout-components';
import MeetingStatistics from '../../../flowtrace-components/MeetingStatistics/Extension';

const explanation = []
explanation.push(<h4 key="header" className="heading-2 pb-1">Meeting Costs for Google/Outlook Overview</h4>)
explanation.push(<p key="paragraph1">We track your users adoption of the extension when your users are authenticated with our servers. This requires either SSO login, or centralized key authorizaion.</p>)
explanation.push(<p key="paragraph2">Here you can see what type of calendars your users use our tools, and what type of actions they take.</p>)
explanation.push(<p key="paragraph3">You can also find demographic information like usage location from this page.</p>)

export default function MeetingDashboard(props) {
  return (
    <Fragment>
      <PageTitle key="title" titleHeading="Meeting Costs for Google Calendar and Outlook Plugin Usage" titleDescription="Follow the adoption and usage of the extension across the company" explanation={explanation}/>

      <MeetingStatistics flowtraceUser={ props.flowtraceUser }/>
    </Fragment>
  );
}
